import { create } from 'zustand';

import { Lesson, LessonState, LessonActions, Note, TOC, NewNoteDTO } from './types';

const initialLessonState: LessonState = {
  lessonId: undefined,
  lesson: undefined,
  bossSectionId: undefined,
  sectionId: undefined,

  toc: [],

  notes: [],
  newNote: undefined,
  activeNoteId: undefined,
};

export const useLessonStore = create<LessonState & LessonActions>((set) => ({
  ...initialLessonState,

  setLessonId: (lessonId?: string) => set({ lessonId }),
  setLesson: (lesson?: Lesson) => set({ lesson }),
  setBossSectionId: (bossSectionId?: string) => set({ bossSectionId }),
  setSectionId: (sectionId?: string) => set({ sectionId }),

  setTOC: (toc: TOC[]) => set({ toc }),
  pushTOC: (toc: TOC) => set((state) => ({ toc: [...state.toc, toc] })),
  completeTOCSection: (sectionId: string, articleIndex: number) =>
    set((state) => {
      const newToc = [...state.toc];
      const sectionIndex = newToc[articleIndex].sections?.findIndex((s) => s.id === sectionId);

      if (
        sectionIndex === undefined ||
        sectionIndex === -1 ||
        newToc[articleIndex].sections![sectionIndex].completed
      ) {
        return state;
      }

      newToc[articleIndex].sections![sectionIndex].completed = true;

      if (newToc[articleIndex].sections!.every((s) => s.completed)) {
        newToc[articleIndex].completed = true;
      }

      return { toc: newToc };
    }),
  completeTOCQuiz: (quizId: string) =>
    set((state) => {
      const newToc = [...state.toc];
      const quizIndex = newToc.findIndex((a) => a.id === quizId);

      if (quizIndex === undefined || quizIndex === -1 || newToc[quizIndex].completed) {
        return state;
      }

      newToc[quizIndex].completed = true;

      return { toc: newToc };
    }),
  removeTOCQuiz: (quizId: string) =>
    set((state) => ({ toc: state.toc.filter((a) => a.id !== quizId) })),
  failTOCQuiz: (quizId: string) =>
    set((state) => {
      const newToc = [...state.toc];
      const quizIndex = newToc.findIndex((a) => a.id === quizId);

      if (quizIndex === undefined || quizIndex === -1 || newToc[quizIndex].failed) {
        return state;
      }

      newToc[quizIndex].failed = true;

      return { toc: newToc };
    }),
  resetTOCQuiz: (quizId: string) =>
    set((state) => {
      const newToc = [...state.toc];
      const quizIndex = newToc.findIndex((a) => a.id === quizId);

      if (quizIndex === undefined || quizIndex === -1 || !newToc[quizIndex].failed) {
        return state;
      }

      newToc[quizIndex].failed = false;

      return { toc: newToc };
    }),

  setNotes: (notes: Note[]) => set({ notes }),
  pushNote: (note: Note) => set((state) => ({ notes: [note, ...state.notes] })),
  removeNote: (id: string) =>
    set((state) => ({ notes: state.notes.filter((note) => note.id !== id) })),
  setNewNote: (newNote?: NewNoteDTO) => set({ newNote }),
  setActiveNoteId: (activeNoteId?: string) => set({ activeNoteId }),
}));
